/* eslint-disable no-undef */
import { Swiper, Navigation } from 'swiper/dist/js/swiper.esm.js'

Swiper.use([Navigation])
jQuery(function ($) {
  // initialize swiper when document ready
  const swiperElem = $('.swiper-container.custom-slider')
  if (swiperElem.length === 0) {
    return
  }
  const swiper = new Swiper(swiperElem, {
    slidesPerView: 3,
    spaceBetween: 40,
    watchOverflow: true,
    autoHeight: false,
    breakpoints: {
      767: {
        slidesPerView: 2
      },
      600: {
        slidesPerView: 1
      }
    },
    navigation: {
      nextEl: $(swiperElem).siblings('.swiper-button-next'),
      prevEl: $(swiperElem).siblings('.swiper-button-prev')
    }
  })
  swiper.init()
})
